import { useEffect, useState } from "react";
import { Download, Smartphone } from "lucide-react";
import { canInstall, isInstalledApp, isIOS, onInstallChange, promptInstall } from "@/lib/readingApp";

const HELP = {
  ios: ["iPhone / iPad: open this page in Safari, tap Share, then \"Add to Home Screen\".", "iPhone / iPad : ouvrez cette page dans Safari, touchez Partager puis « Sur l'écran d'accueil »."],
  other: ["Open your browser menu (⋮) and tap \"Install app\" or \"Add to Home screen\".", "Ouvrez le menu du navigateur (⋮) puis « Installer l'application » ou « Ajouter à l'écran d'accueil »."],
};

export function InstallApp({ label = "Installer l'appli · Install the app", testId = "install-reading-app" }) {
  const [, setTick] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => onInstallChange(() => setTick((n) => n + 1)), []);
  if (isInstalledApp()) return null;
  const install = async () => { if (!canInstall() || !(await promptInstall())) setHelp(true); };
  const [en, fr] = HELP[isIOS() ? "ios" : "other"];
  return (
    <div className="mt-3" data-testid={testId}>
      <button onClick={install} data-testid={`${testId}-btn`}
        className="inline-flex items-center gap-2 rounded-full bg-blue-600 text-white border-[3px] border-slate-900 px-5 py-2.5 font-bold shadow-[3px_3px_0_0_#0F172A] hover:-translate-y-0.5 transition-transform">
        <Download size={18} /> {label}
      </button>
      {help && (
        <p className="mt-3 text-sm max-w-md" data-testid={`${testId}-help`}>{fr}<span className="block text-slate-600">{en}</span></p>
      )}
    </div>
  );
}

function AppRow({ icon, title, text, children }) {
  return (
    <div className="flex flex-1 min-w-[260px] gap-3">
      <img src={icon} alt="" className="w-14 h-14 shrink-0" />
      <div className="text-sm"><b className="block">{title}</b>{text}{children}</div>
    </div>
  );
}

// Parent dashboard: the two apps (hidden inside an installed app)
export function ReadingAppCard() {
  if (isInstalledApp()) return null;
  return (
    <div className="mb-6 rounded-2xl border-2 border-slate-900 bg-yellow-100 px-5 py-4 shadow-[4px_4px_0_0_#0F172A]" data-testid="reading-app-card">
      <b className="flex items-center gap-1.5 mb-3"><Smartphone size={16} /> Nos applis sur le téléphone · Our apps for your phone</b>
      <div className="flex flex-wrap gap-5">
        <AppRow icon="/logo192.png" title="Anou Appran" text="Everything: all subjects, the Reading kit, plans and payments. · Tout : matières, kit Lecture, abonnements.">
          <InstallApp label="Installer · Install" testId="install-full-app" />
        </AppRow>
        <AppRow icon="/reading-app-192.png" title="Anou Appran Lecture" text="Only the Reading kit (English & French). · Uniquement le kit Lecture.">
          <a href="/lecture" className="mt-3 inline-block rounded-full bg-white border-2 border-slate-900 px-4 py-2 font-bold" data-testid="reading-app-open">Ouvrir · Open →</a>
        </AppRow>
      </div>
    </div>
  );
}
